import { render, staticRenderFns } from "./MagazineIntro.vue?vue&type=template&id=fed51f0a&"
import script from "./MagazineIntro.vue?vue&type=script&lang=js&"
export * from "./MagazineIntro.vue?vue&type=script&lang=js&"
import style0 from "./MagazineIntro.vue?vue&type=style&index=0&id=fed51f0a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports